import { render, staticRenderFns } from "./ImportDuplicateModal.vue?vue&type=template&id=c8deacfe&scoped=true&"
import script from "./ImportDuplicateModal.vue?vue&type=script&lang=js&"
export * from "./ImportDuplicateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8deacfe",
  null
  
)

export default component.exports